exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.r-header__underline[data-v-23e3b7da] {\n  width: 120px;\n  height: 3px;\n  background-color: #f92ac2;\n}\n", "", {"version":3,"sources":["/var/www/appv1.carnet-info-logement.com/src/containers/mh-reception/components/mh-reception-detail-header/styles.scss"],"names":[],"mappings":";AACE;EACE,aAAY;EACZ,YAAW;EACX,0BAAmC;CACpC","file":"styles.scss","sourcesContent":[".r-header {\n  &__underline {\n    width: 120px;\n    height: 3px;\n    background-color: rgb(249, 42, 194);\n  }\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-23e3b7da","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/containers/mh-reception/components/mh-reception-detail-header/styles.scss
// module id = rYse
// module chunks = 0